function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 2c-.392 0-.795.131-1.079.399A1.402 1.402 0 007.5 3.417v.708H3v1.417h.75v11.333C3.75 18.04 4.766 19 6 19h9c1.234 0 2.25-.96 2.25-2.125V5.542H18V4.125h-4.5v-.708c0-.37-.139-.751-.422-1.019C12.795 2.132 12.392 2 12 2H9zm0 1.417h3v.708H9v-.708zM5.25 5.542h10.5v11.333c0 .393-.334.708-.75.708H6c-.416 0-.75-.315-.75-.708V5.542zm1.5 2.125v7.791h1.5V7.667h-1.5zm3 0v7.791h1.5V7.667h-1.5zm3 0v7.791h1.5V7.667h-1.5z"
});
function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
}
export default SvgTrash;